// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q1-c";
export var backButton = "_q1-4";
export var backIcon = "_q1-5";
export var chevronShortcut = "_q1-6";
export var container = "_q1-1";
export var editor = "_q1-8";
export var editorWrapper = "_q1-7";
export var prefix = "_q1-2";
export var searchIcon = "_q1-3";
export var suffix = "_q1-9";
export var suffixContent = "_q1-a";
export var suffixText = "_q1-b";
export var wrapper = "_q1-0";